import { create } from 'zustand';

interface LoginModalState {
	isOpen: boolean;
	/** Optional message displayed in the modal (e.g. "Your session has expired") */
	message: string | null;
	open: (message?: string) => void;
	close: () => void;
}

/**
 * Global store for login modal visibility.
 *
 * Used by:
 * - useAuthGate() to open the modal when an auth-requiring action is attempted
 * - portalTokenService to open the modal on session expiry
 * - UserMenu "Sign In" button
 * - LoginModal component itself
 */
export const useLoginModalStore = create<LoginModalState>((set) => ({
	isOpen: false,
	message: null,
	open: (message?: string) => set({ isOpen: true, message: message ?? null }),
	close: () => set({ isOpen: false, message: null }),
}));
